import { FormLayoutModule } from '../form-layout/form-layout.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { ArrearsListingWidgetEffects } from '@feature/_app_modules/arrears-listing-widget/effects/arrears-listing-widget.effects';
import * as ArrearsListingWidgetReducers from '../arrears-listing-widget/reducers/arrears-listing-widget.reducers';
import { ArrearsListingWidgetFacadeService } from "@feature/_app_modules/arrears-listing-widget/services/arrears-listing-widget-facade.service";
import { ArrearsListingWidgetComponent } from "@feature/_app_modules/arrears-listing-widget/containers/arrears-listing-widget.component";
import { FormsModule } from '@angular/forms';
import { ArrearsItemFormComponent } from './components/arrears-item-form.component';
import { PanelModule } from 'primeng/panel';
import { ArrearsItemComponent } from './containers/arrears-item-component/arrears-item.component';

@NgModule({
  declarations: [
    ArrearsListingWidgetComponent,
    ArrearsItemFormComponent,
    ArrearsItemComponent
  ],
  exports: [
    ArrearsListingWidgetComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ArrearsListingWidget', ArrearsListingWidgetReducers.reducer),
    EffectsModule.forFeature([ArrearsListingWidgetEffects]),
    FormLayoutModule,
    FormsModule,
    PanelModule
    ],
  providers: [
    ArrearsListingWidgetFacadeService
  ]
})
export class ArrearsListingWidgetModule { }
